import { FaArrowUp, FaEnvelope, FaFacebook, FaInstagram, FaLinkedin, FaMapMarkerAlt, FaPhone } from './Icon';
import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import './Footer.css';

export default function Footer() {
  const { t } = useLang();
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const services = [
    { label: t('footer.srvWeb'),       slug: 'developpement-web-mobile' },
    { label: t('footer.srvDesign'),    slug: 'design-graphique' },
    { label: t('footer.srvCommunity'), slug: 'community-management' },
    { label: t('footer.srvAudio'),     slug: 'audiovisuel-motion-design' },
    { label: t('footer.srvMarketing'), slug: 'marketing-digital' },
    { label: t('footer.srvStrategy'),  slug: 'strategie-digitale' },
    { label: t('footer.srvIA'),        slug: 'solutions-ia-sur-mesure' },
    { label: t('footer.srvSeo'),       slug: 'seo-sea' },
  ];

  return (
    <footer className="nx-footer">
      <div className="footer-aurora" aria-hidden="true" />

      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <img src="/logo.png" alt="Nexia Digital" width="126" height="36" loading="lazy" decoding="async" style={{ height: 36, objectFit: 'contain' }} />
              </Link>
              <p className="footer-tagline">{t('footer.tagline')}</p>
              <div className="footer-socials">
                <a href="https://www.facebook.com/profile.php?id=61579473161822" target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebook /></a>
                <a href="https://www.instagram.com/nexia_digital1/" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
                <a href="https://www.linkedin.com/company/nexiadigital/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
              </div>
            </div>

            <div className="footer-col">
              <h4>{t('footer.servicesTitle')}</h4>
              <ul>
                {services.map((s) => (
                  <li key={s.slug}>
                    <Link to={`/services/${s.slug}`}>{s.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-col">
              <h4>{t('footer.navigationTitle')}</h4>
              <ul>
                <li><Link to="/">{t('footer.navHome')}</Link></li>
                <li><Link to="/a-propos">{t('footer.navAbout')}</Link></li>
                <li><Link to="/portfolio">{t('footer.navPortfolio')}</Link></li>
                <li><Link to="/contact">{t('footer.navContact')}</Link></li>
                <li><Link to="/devis">{t('footer.navDevis')}</Link></li>
                <li><Link to="/apporteurs">{t('footer.navApporteurs')}</Link></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>{t('footer.contactTitle')}</h4>
              <ul className="footer-contact-list">
                <li>
                  <FaMapMarkerAlt />
                  <span>145 Rue de Noisy-le-Sec, 93260 Les Lilas, Paris (Île-de-France)</span>
                </li>
                <li>
                  <FaPhone />
                  <a href="tel:+33775215157">+33 7 75 21 51 57</a>
                </li>
                <li>
                  <FaEnvelope />
                  <a href="mailto:contact@nexia-digital.net">contact@nexia-digital.net</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>
            © {new Date().getFullYear()} Nexia Digital. {t('footer.rights')} —{' '}
            <Link to="/mentions-legales" style={{color:'rgba(255,255,255,0.4)', fontSize:'0.8rem'}}>
              {t('footer.legal')}
            </Link>
          </p>
          <p>
            {t('footer.madeWith')} <i className="fa-solid fa-heart" style={{color: 'var(--accent1)'}} /> {t('footer.madeBy')}
          </p>
          <button className="scroll-top-btn" onClick={scrollTop} aria-label={t('footer.scrollTop')}>
            <FaArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
}
